export default __webpack_public_path__ + "static/media/ground_mark.60aeb4df.png";